import { Tabs, TabList, TabPanels, TabPanel, TabsProps } from '@chakra-ui/react'
import CustomTab from '../components/UI/CustomTab'
import React from 'react'

type Tab = {
  title?: string | undefined
  icon?: JSX.Element | undefined
  loading?: boolean | undefined
  bg?: string | undefined
}
type CustomTabProps = {
  tabs: Tab[]
  tabPanels: {
    component: JSX.Element
  }[]
  borderColor?: string
} & Omit<TabsProps, 'children'>

const CustomTabContainer: React.FC<CustomTabProps> = ({
  tabs,
  tabPanels,
  borderColor,
  ...rest
}) => {
  return (
    <Tabs colorScheme="gray" variant="line" {...rest}>
      <TabList borderColor={borderColor}>
        {tabs?.map((tab, index) => (
          <CustomTab tab={tab} key={tab.title || index} />
        ))}
      </TabList>
      <TabPanels>
        {tabPanels.map((tabPanel, index) => (
          <TabPanel key={tabs[index]?.title || index} px={0} pt={6}>
            {tabPanel.component}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  )
}
CustomTabContainer.defaultProps = {
  borderColor: 'gray.200'
}
export default CustomTabContainer
